@if (title) {
  <h2>{{title}}</h2>
}
@if (!reviews) {
  <mat-spinner color="secondary"></mat-spinner>
}
@if (reviews && !cycle) {
  @for (review of reviews; track review) {
    <mbnm-review [review]="review">
    </mbnm-review>
  }
}
@if (reviews && cycle) {
  <button mat-icon-button class="left" (click)="changeIndex(-1)">
    <mat-icon svgIcon="chevron-left"></mat-icon>
  </button>
  <mat-tab-group class="reviews" #reviewTab headerPosition="below" dynamicHeight="true" [@.disabled]="true"
    (swipeleft)="changeIndex(1)" (swiperight)="changeIndex(-1)">
    @for (review of reviews; track review) {
      <mat-tab>
        <mbnm-review [review]="review" class="cycle" [customerDisplayStyle]="customerDisplayStyle">
        </mbnm-review>
      </mat-tab>
    }
  </mat-tab-group>
  <button mat-icon-button class="right" (click)="changeIndex(1)">
    <mat-icon svgIcon="chevron-right"></mat-icon>
  </button>
}
@if (reviews && reviews.length == 0) {
  <div>
    No Reviews Found!
  </div>
}
